// extracted by mini-css-extract-plugin
export default {"recos":"k6-z","productCardOverride":"l6-z","rowHasBadge":"m6-z"};